import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider, useQueryRequest} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponse} from './core/QueryResponseProvider'
import {Table} from './Table'
import {KTCard} from '../../../../../_metronic/helpers'
import {Header} from '../../../../../_component/table/Header'
import {deleteJob} from './core/_requests'
import {useState} from 'react'
import {CreateApplicationModal} from '../../application/applications-list/CreateApplicationModal'

const List = () => {
  const {
    selected,
    clearSelected,
  } = useListView()
  const {refetch, isLoading} = useQueryResponse()
  const {updateState} = useQueryRequest()

  const [jobIdToApply, setJobIdToApply] = useState<string | null>(null)

  return (
    <>
      <KTCard>
        <Header
          updateState={updateState}
          isLoading={isLoading}
          refetch={refetch}
          selected={selected}
          clearSelected={clearSelected}
          deleteAction={deleteJob}
          fields={['status']}
          title='Job'
          customCreatePath='/jobs/new'
          searchAble={true}
          searchFields={['title', 'department', 'location']}
        />
        <Table openApplyModal={(id: string) => setJobIdToApply(id)} />
      </KTCard>

      {jobIdToApply && (
        <CreateApplicationModal
          show={!!jobIdToApply}
          handleClose={() => setJobIdToApply(null)}
          onSuccess={() => {
            setJobIdToApply(null)
          }}
          initialJobId={jobIdToApply}
        />
      )}
    </>
  )
}

export const JobsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <List />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
